// extracted by mini-css-extract-plugin
export var chip = "_db-0";
export var filterDropdown = "_db-5";
export var filterItem = "_db-6";
export var icon = "_db-1";
export var removeButton = "_db-3";
export var removeIcon = "_db-4";
export var separator = "_db-2";